// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"36f9b44b","453":"2a6fbb22"}[chunkId] + ".chunk.js";
};